import React, { useEffect } from 'react'
import cx from 'classnames'
import { Icon, l } from '@manychat/manyui'

import { useAppDispatch, useAppSelector } from 'reduxTyped'
import { CmsAnalytics } from 'apps/cms/lib/analytics'
import { VIEW_DISPLAY_MODE_LS_KEY, ViewDisplayMode } from 'apps/cms/lib/constants'
import { contentManagementActions, contentManagementSelectors } from 'apps/cms/store'
import { localStorage } from 'utils'

import cm from './ViewModeSwitcher.module.css'

const ICON_SIZE = 16

export const ViewModeSwitcher = () => {
  const dispatch = useAppDispatch()

  const displayMode = useAppSelector(contentManagementSelectors.getViewDisplayMode)

  const toggleDisplayMode = () => {
    const newDisplayMode =
      displayMode === ViewDisplayMode.GRID ? ViewDisplayMode.LIST : ViewDisplayMode.GRID

    dispatch(contentManagementActions.setViewDisplayMode(newDisplayMode))
    localStorage.setItem(VIEW_DISPLAY_MODE_LS_KEY, newDisplayMode)
    CmsAnalytics.logToggleDisplayMode({ displayMode: newDisplayMode })
  }

  useEffect(() => {
    const savedValue = localStorage.getItem(VIEW_DISPLAY_MODE_LS_KEY) as ViewDisplayMode

    if ([ViewDisplayMode.GRID, ViewDisplayMode.LIST].includes(savedValue)) {
      dispatch(contentManagementActions.setViewDisplayMode(savedValue))
    }
  }, [dispatch])

  return (
    <button onClick={toggleDisplayMode} className={cx('text-body-sm', cm.viewSwitcher)}>
      {displayMode === ViewDisplayMode.GRID && <Icon.TableView size={ICON_SIZE} />}

      {displayMode === ViewDisplayMode.LIST && <Icon.MosaicView size={ICON_SIZE} />}

      <span>
        {displayMode === ViewDisplayMode.GRID && <span>{l.translate('View as list')}</span>}

        {displayMode === ViewDisplayMode.LIST && <span>{l.translate('View as grid')}</span>}
      </span>
    </button>
  )
}
